import { render, staticRenderFns } from "./Charactercreater.vue?vue&type=template&id=e5908348&scoped=true"
import script from "./Charactercreater.vue?vue&type=script&lang=js"
export * from "./Charactercreater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5908348",
  null
  
)

export default component.exports